module.exports = __webpack_public_path__ + "media/images/favicon-4bcd45981ddff96f9662350e7e677825.png";